import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';
import React, { FC } from 'react';
import { FaMoneyCheckDollar } from 'react-icons/fa6';
const MoneyIcon = FaMoneyCheckDollar as React.ComponentType<any>;
const MoneyAlert: FC<AlertProps> = ({
  title = 'Success',
  iconNode = <MoneyIcon size={24} className="text-accent" />,
  description = 'This is just a success message, but we are so glad you are here.',
  ...props
}) => {
  return (
    <Alert
      intent="success"
      iconNode={iconNode}
      title={title}
      description={description}
      {...props}
    />
  );
};
export default MoneyAlert;
